<template>
  <div class="grid-container">
    <div
      class="store-search-wrapper"
      :class="{ 'filters-collapsed': !filtersVisible }"
    >
      <div class="store-controls store-controls--top">
        <FiltersToggle />
        <div class="store-controls__inner">
          <ResultsSort />
          <Pagination />
        </div>
      </div>

      <div class="store-sidebar-wrapper">
        <FiltersToggle />
        <Sidebar />
      </div>

      <div
        class="store-results-wrapper"
        :class="{ 'store-results-wrapper--expanded': !filtersVisible }"
      >
        <ActiveFilters />
        <Results />

        <div class="store-controls store-controls--bottom">
          <Pagination />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Sidebar from './components/Sidebar'
import ActiveFilters from './components/ActiveFilters'
import Results from './components/Results'
import ResultsSort from './components/ResultsSort'
import Pagination from './components/Pagination'
import FiltersToggle from './components/FiltersToggle'

export default {
  name: 'StoreSearch',

  components: {
    Sidebar,
    ActiveFilters,
    Results,
    ResultsSort,
    Pagination,
    FiltersToggle
  },

  computed: {
    ...mapState([
      'filtersVisible'
    ])
  },

  created () {
    this.getInitialData()
  },

  methods: {
    ...mapMutations([
      'loadInitialData'
    ]),

    getInitialData () {
      const initialData = JSON.parse(document.getElementById('search-data').textContent)
      this.loadInitialData(initialData)
    },
  }
}
</script>
